import { SubmitDepositActions } from './actions'
import {
  SUBMIT_DEPOSIT,
  SUBMIT_DEPOSIT_CLEAR,
  SUBMIT_DEPOSIT_ERROR,
  SUBMIT_DEPOSIT_SUCCESS
} from './actionTypes'
import { SubmitDepositResponse } from './types'

export type SubmitDepositState = {
  data?: SubmitDepositResponse
  error?: string
  loading: boolean
}

export const INITIAL_STATE: SubmitDepositState = {
  loading: false
}

export default (state: SubmitDepositState = INITIAL_STATE, action: SubmitDepositActions) => {
  if (!action) return state
  switch (action.type) {
    case SUBMIT_DEPOSIT:
      return { loading: true }
    case SUBMIT_DEPOSIT_SUCCESS:
      return { data: action.payload, loading: false }
    case SUBMIT_DEPOSIT_ERROR:
      return { error: action.payload, loading: false }
    case SUBMIT_DEPOSIT_CLEAR:
      return INITIAL_STATE
    default:
      return state
  }
}
